import { render } from "./GroupBookingBanner.vue?vue&type=template&id=dc0e9b98&scoped=true"
import script from "./GroupBookingBanner.vue?vue&type=script&lang=js"
export * from "./GroupBookingBanner.vue?vue&type=script&lang=js"

import "./GroupBookingBanner.vue?vue&type=style&index=0&id=dc0e9b98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0e9b98"]])

export default __exports__